import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const wasteStreamsApi = createApi({
    reducerPath: "wasteStreamsApi",
    baseQuery: baseQueryWithReauth,
    tagTypes: ["WasteStreams"],
    endpoints: (builder) => ({
        // Get all Waste Streams
        getWasteStreams: builder.query({
            query: () => "/waste-streams",
            transformResponse: (response) => response.data || response,
            providesTags: ["WasteStreams"],
        }),

        // Get a single Waste Stream
        getWasteStreamById: builder.query({
            query: (id) => `/waste-streams/${id}`,
            transformResponse: (response) => response.data || response,
            providesTags: (result, error, id) => [{ type: "WasteStreams", id }],
        }),

        // Create a new Waste Stream
        createWasteStream: builder.mutation({
            query: (wasteStream) => ({
                url: `/waste-streams`,
                method: "POST",
                body: wasteStream,
            }),
            transformResponse: (response) => response.data || response,
            invalidatesTags: ["WasteStreams"],
        }),

        // Update an existing Waste Stream
        updateWasteStream: builder.mutation({
            query: ({ id, body, ...wasteStream }) => ({
                url: `/waste-streams/${id}`,
                method: "PUT",
                body: body || wasteStream,
            }),
            invalidatesTags: ["WasteStreams"],
        }),

        // Delete an existing Waste Stream
        deleteWasteStream: builder.mutation({
            query: (id) => ({
                url: `/waste-streams/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["WasteStreams"],
        }),
    }),
});

export const {
    useGetWasteStreamsQuery,
    useGetWasteStreamByIdQuery,
    useCreateWasteStreamMutation,
    useUpdateWasteStreamMutation,
    useDeleteWasteStreamMutation,
} = wasteStreamsApi;
